import { Skeleton } from "@/components/ui/skeleton";
import React from "react";

export const MyConnectionsSkeleton: React.FC = () => {
  return (
    <div className="space-y-8 pt-[50px]">
      {/* Header */}
      <div className="flex flex-col space-y-2">
        <div className="flex items-center gap-3 mb-2">
          <Skeleton className="h-8 w-8 rounded-sm" /> {/* Icon skeleton */}
          <Skeleton className="h-8 w-48" /> {/* Title skeleton */}
        </div>
        <Skeleton className="h-5 w-80" /> {/* Description skeleton */}
      </div>

      {/* Search and Filters */}
      <div className="relative">
        <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 items-end">
          {/* Search Bar */}
          <div className="flex-1">
            <div className="relative">
              <Skeleton className="h-12 w-full rounded-md" />{" "}
              {/* Search bar skeleton */}
            </div>
          </div>

          {/* Category Filter */}
          <div className="w-full lg:w-48">
            <Skeleton className="h-12 w-full rounded-md" />{" "}
            {/* Category filter skeleton */}
          </div>
        </div>
      </div>

      {/* Results - Separated Sections */}
      <div className="space-y-12">
        {/* Connected Integrations */}
        <div>
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center space-x-3">
              <Skeleton className="h-6 w-6 rounded-full" />{" "}
              {/* Icon skeleton */}
              <Skeleton className="h-8 w-56" /> {/* Section title skeleton */}
              <Skeleton className="h-6 w-8 rounded-md" /> {/* Badge skeleton */}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
              <Skeleton key={i} className="p-4 rounded-lg h-[210px]" />
            ))}
          </div>
        </div>

        {/* Available Integrations */}
        <div>
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center space-x-3">
              <Skeleton className="h-6 w-6 rounded-full" />{" "}
              {/* Icon skeleton */}
              <Skeleton className="h-8 w-48" /> {/* Section title skeleton */}
              <Skeleton className="h-6 w-8 rounded-md" /> {/* Badge skeleton */}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <Skeleton key={i} className="p-4 rounded-lg h-[210px]" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
